import React from 'react';
import ErrorPlaceholder from 'src/components/ErrorPlaceholder';

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPlaceholder />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
